import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton,} from "../buttons/ReloadRecordsButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useParams} from "react-router-dom";
import {moduleConfig} from "../config";
import { GenerateCustomerSubscriptionsButton } from '../../test-data-generator/buttons/GenerateCustomerSubscriptionsButton.tsx';


const useTools = () => {

    const {id: customerId} = useParams();
    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<FilterRecordsButton key='filter'/>);
    tools.push(<ReloadRecordsButton key='reload'/>);

    // show delete and add buttons only if the page is child to customer detail page
    if (customerId) {

        if (allowedActions.includes(rbacActions.DeleteSubscription)) {
            tools.push(<DeleteRecordButton key='delete' />);
        }

        if (allowedActions.includes(rbacActions.CreateSubscription)) {
            tools.push(<AddRecordButton key='add'/>);
            tools.push(<GenerateCustomerSubscriptionsButton key='generate' />);
        }

    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.plural)}
            tools={useTools()}
        />
    );
};
